import { render, staticRenderFns } from "./SdvStat.vue?vue&type=template&id=e6ee6cfa&"
import script from "./SdvStat.vue?vue&type=script&lang=js&"
export * from "./SdvStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports